export const iconFontAwesomeSocialMessage = (
	<i className="fa-solid fa-message"></i>
);
